// removed by extract-text-webpack-plugin
module.exports = {"container":"Payment__container___1M1H_","button":"Payment__button___3UyHD","dropInContainer":"Payment__dropInContainer___oielT","navBarSpace":"Payment__navBarSpace___23gnN","removePadding":"Payment__removePadding___1ttCB","buttonContainer":"Payment__buttonContainer___2GTL_","greenIndicator":"Payment__greenIndicator___11zdL"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Payment/Payment.scss
// module id = 1580
// module chunks = 0